import { render } from "./IconVolleyball.vue?vue&type=template&id=41fa6c80&ts=true"
import script from "./IconVolleyball.vue?vue&type=script&lang=ts"
export * from "./IconVolleyball.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__